import { defineComponent, PropType } from 'vue';

export const LocalizedDate = defineComponent({
    props: {
        format: String,
        tag: {
            required: false,
            type: String,
        },
        // Cast needed: Vue's array-shorthand type inference for [Number, Date] resolves to `number | string`, not `number | Date`.
        value: { type: [Number, Date] as PropType<number | Date>, required: true },
    },
    render(createElement) {
        return createElement(this.tag || 'span', this.$d(this.value, this.format as string));
    },
})
